import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import {commonFiltersValue, country, isLoadingCommonFilters, isSystemBusy} from "@signals"
import { CatalogueDetailsIsEmpty, catalogueDetailsTableData } from "../../@signals"


export default function useCatalogueDetailsData() {
	const { showToast } = useAppToast()

	// const data = useSignal([])

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			catalogueDetailsTableData.value = []
			postSubmit(`${WEBBACK_V2_API}/catalogue/details/context`, { ...commonFiltersValue.value, country: country.value[0] }).then(res => {
				if (!res?.length) CatalogueDetailsIsEmpty.value = true
				catalogueDetailsTableData.value = res
			}).catch(() => isSystemBusy.value = true
			).finally(() => {
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	return {
		tableData: catalogueDetailsTableData.value
	}
}